module.exports = require('buffer')



//////////////////
// WEBPACK FOOTER
// ./~/safe-buffer/browser.js
// module id = 13
// module chunks = 0